// Predictive search overlay — uses Shopify /search/suggest.json
// All dynamic content built with createElement + textContent (no innerHTML for user data)
(function () {
  var overlay = document.getElementById('HeaderSearchOverlay');
  if (!overlay) return;

  var toggle      = document.querySelector('[data-search-toggle]');
  var input       = overlay.querySelector('[data-search-input]');
  var listEl      = overlay.querySelector('[data-search-list]');
  var defaultEl   = overlay.querySelector('[data-search-default]');
  var viewAll     = overlay.querySelector('[data-search-viewall]');
  var viewAllLink = overlay.querySelector('[data-search-viewall-link]');
  var closeBtns   = overlay.querySelectorAll('[data-search-close]');

  function open() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    overlay.removeAttribute('inert');
    document.body.classList.add('search-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    setTimeout(function () { if (input) input.focus(); }, 50);
  }
  function close() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('inert', '');
    document.body.classList.remove('search-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  if (toggle) toggle.addEventListener('click', open);
  closeBtns.forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });

  function fetchSuggest(q) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
    return fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function formatMoney(amount) {
    var n = parseFloat(amount);
    if (isNaN(n)) return '';
    return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function clearChildren(el) {
    while (el.firstChild) el.removeChild(el.firstChild);
  }

  function buildResultRow(p) {
    // Anchor wrapper
    var a = document.createElement('a');
    a.className = 'header-search-result';
    a.href = p.url || '#';

    // Image
    var imgUrl = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
    if (imgUrl) {
      var imgSm = imgUrl.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2');
      var img = document.createElement('img');
      img.className = 'header-search-result__img';
      img.src = imgSm;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 56;
      img.height = 56;
      a.appendChild(img);
    } else {
      var imgPh = document.createElement('div');
      imgPh.className = 'header-search-result__img';
      a.appendChild(imgPh);
    }

    // Info
    var info = document.createElement('div');
    info.className = 'header-search-result__info';
    var title = document.createElement('p');
    title.className = 'header-search-result__title';
    title.textContent = p.title || '';
    info.appendChild(title);

    if (p.price) {
      var price = document.createElement('span');
      price.className = 'header-search-result__price';
      price.textContent = formatMoney(p.price);
      info.appendChild(price);
    }

    a.appendChild(info);
    return a;
  }

  function renderEmpty(q) {
    clearChildren(listEl);
    var div = document.createElement('div');
    div.className = 'header-search-results__empty';
    div.textContent = 'Sin resultados para «' + q + '». Prueba con otro término.';
    listEl.appendChild(div);
    viewAll.hidden = true;
  }

  function renderError() {
    clearChildren(listEl);
    var div = document.createElement('div');
    div.className = 'header-search-results__empty';
    div.textContent = 'Hubo un error al buscar. Intenta de nuevo.';
    listEl.appendChild(div);
    viewAll.hidden = true;
  }

  function renderResults(items, q) {
    clearChildren(listEl);
    if (!items || items.length === 0) {
      renderEmpty(q);
      return;
    }
    items.forEach(function (p) {
      listEl.appendChild(buildResultRow(p));
    });
    viewAllLink.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
    viewAll.hidden = false;
  }

  var debounceTimer;
  var lastQuery = '';

  if (input) input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(debounceTimer);

    if (q.length < 2) {
      clearChildren(listEl);
      viewAll.hidden = true;
      if (defaultEl) defaultEl.style.display = '';
      return;
    }

    if (defaultEl) defaultEl.style.display = 'none';
    if (q === lastQuery) return;
    lastQuery = q;

    debounceTimer = setTimeout(function () {
      fetchSuggest(q).then(function (data) {
        var items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(items, q);
      }).catch(renderError);
    }, 180);
  });
})();
